import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { isExpectedError } from "~/lib/errors";
import { logger } from "~/lib/logger";
import { Button } from "~/ui-kit/button";

export const RootErrorBoundary = () => {
  const error = useRouteError();

  const handleReload = () => window.location.reload();

  useEffect(() => {
    if (isExpectedError(error)) {
      // Log expected errors to DataDog
      logger.error(
        `Expected error occurred: ${error.message}`,
        {
          errorType: error.context?.errorType || "expected_error",
          errorName: error.name,
          ...error.context,
        },
        error,
      );

      return;
    }

    // Log unexpected errors to DataDog
    logger.error(
      `Unexpected error occurred: ${error instanceof Error ? error.message : "Unknown error"}`,
      {
        errorType: "unexpected_error",
        errorName: error instanceof Error ? error.name : "Unknown",
      },
      error instanceof Error ? error : new Error(String(error)),
    );
  }, [error]);

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2 p-6 text-center">
        <h1 className="text-4xl font-bold">
          {error.status} {error.statusText}
        </h1>
        {error.data ? <p>{String(error.data)}</p> : null}
        <Button onClick={handleReload} className="mt-4">
          Reload Page
        </Button>
      </div>
    );
  }

  const message = error instanceof Error ? error.message : "Unknown error";

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-2 p-6 text-center">
      <h1 className="text-3xl font-bold">Something went wrong</h1>
      <p className="text-muted-foreground max-w-md">{message}</p>
      <Button onClick={handleReload} className="mt-4">
        Reload Page
      </Button>
    </div>
  );
};
